import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectNews,
  selectActiveIndexNews,
  selectCurrentPageNews,
  selectActiveNews,
  setSearchValue,
} from "../../redux/slices/newsSlice";
import {
  fetchNews,
  setFirstActiveNewsAction,
  nextActiveNewsAction,
  prevActiveNewsAction,
  addSavedNews,
  removeSavedNews,
  fetchNewsById,
} from "../../redux/actions/newsActions";
import { AppDispatch } from "../../redux/store";
import { Button, Col, Input, message, Row, Card, Image } from "antd";
import classes from "./News.module.css";
import logoGlobe from "../../assets/images/brieffo.svg";
import logo from "../../assets/images/lightLogo.svg";
import WolrdIcon from "../../assets/images/WorldIcon.svg";
import appstore from "../../assets/images/appStore.svg";
import googleplay from "../../assets/images/googlePlay.svg";
import noImage from "../../assets/images/noNewsImage.png";
import { RxHamburgerMenu, RxDividerVertical } from "react-icons/rx";
import { IoIosArrowRoundForward, IoIosShareAlt } from "react-icons/io";
import { FiSearch } from "react-icons/fi";
import { FaGlobeEurope } from "react-icons/fa";
import { Tooltip } from "antd";

import { selectNewsLoading } from "../../redux/slices/newsSlice";
import "swiper/css";
import "swiper/css/autoplay";
import {
  Mousewheel,
  Keyboard,
  Navigation,
  A11y,
  Autoplay,
} from "swiper/modules";
import { SwiperNavButtons } from "../../components/SwiperNavButtons/SwiperNavButtons";
import {
  fetchCategories,
  fetchLatestPostByCategory,
} from "../../redux/actions/categoriesActions";
import { selectCategoriesData } from "../../redux/slices/categoriesSlice";
import NewsModal from "../../components/Modal/NewsModal/NewsModal";
import SideDrawer from "../../components/NewsPage/SideDrawer";
import ShareModal from "../../components/NewsPage/ShareModal";
import {
  selectAuthenticated,
  selectUserInfo,
} from "../../redux/slices/authSlice";
import { selectLatestPostByCategory } from "../../redux/slices/latestPostByCategorySlice";
import { loginAnonymously } from "../../redux/actions/auth";
import { HiArrowLeft } from "react-icons/hi2";
import { FaBookmark, FaRegBookmark } from "react-icons/fa";
import { useIsMobile } from "../../hooks/useIsMobile";
import HomeSkeleton from "../../components/skeletons/HomeSkeleton";

import { selectTotalPages } from "../../redux/slices/newsSlice";
import { WeatherWidget } from "../WeatherForecast/WeatherWidget";

const News: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const news = useSelector(selectNews);
  const newsActiveIndex = useSelector(selectActiveIndexNews);
  const currentPage = useSelector(selectCurrentPageNews);
  const activeNews = useSelector(selectActiveNews);
  const isAuthenticated = useSelector(selectAuthenticated);
  const swiperRef = useRef(null);
  const [search, setSearch] = useState("");
  const categories = useSelector(selectCategoriesData);
  const [activeCategory, setActiveCategory] = useState("");
  const navigate = useNavigate();

  const [showNewsModal, setShowNewsModal] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [isBannerVisible, setIsBannerVisible] = useState(true);

  const loading = useSelector(selectNewsLoading);
  const [pageLoading, setPageLoading] = useState(true);

  const [highlightWorld, setHighlightWorld] = useState(false);

  useEffect(() => {
    const afterRegisterTrigger = localStorage.getItem(
      "triggerWorldHintAfterRegister",
    );

    const seenAnonymous = localStorage.getItem("hasSeenWorldHintAnonymous");

    const seenAfterRegister = localStorage.getItem(
      "hasSeenWorldHintAfterRegister",
    );

    let shouldShow = false;
    let seenKeyToSet = "";

    if (afterRegisterTrigger && !seenAfterRegister) {
      shouldShow = true;
      seenKeyToSet = "hasSeenWorldHintAfterRegister";
    }

    if (!afterRegisterTrigger && !seenAnonymous) {
      shouldShow = true;
      seenKeyToSet = "hasSeenWorldHintAnonymous";
    }

    if (shouldShow) {
      setHighlightWorld(true);

      const timer = setTimeout(() => {
        setHighlightWorld(false);
        localStorage.setItem(seenKeyToSet, "true");
        localStorage.removeItem("triggerWorldHintAfterRegister");
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, []);

  const [searchOpen, setSearchOpen] = useState(false);

  const country = localStorage.getItem("country");
  const sourceIds = localStorage.getItem(`sourceIds_${country}`);
  const { Search } = Input;

  const totalPages = useSelector(selectTotalPages);

  //   useEffect(() => {
  //     const fetchData = () => {
  //         dispatch(fetchNews(0, activeCategory, sourceIds,country)).then(() => {
  //             dispatch(setFirstActiveNewsAction());
  //             resetSwiperActiveIndex();
  //         });
  //     }

  //     isAuthenticated
  //         ? fetchData()
  //         : dispatch(loginAnonymously())
  //             .then(fetchData)
  //             .catch((error) => {
  //                 console.error('Anonymous login failed:', error);
  //             });
  // }, [activeCategory]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryFromUrl = params.get("category");

    if (categoryFromUrl && categoryFromUrl !== activeCategory) {
      setActiveCategory(categoryFromUrl);
    }

    const loadAll = async () => {
      try {
        await Promise.all([
          dispatch(
            fetchNews(0, categoryFromUrl || activeCategory, sourceIds, country),
          ),
          dispatch(fetchCategories()),
          dispatch(fetchLatestPostByCategory()),
        ]);

        dispatch(setFirstActiveNewsAction());
        resetSwiperActiveIndex();

        const id = new URLSearchParams(location.search).get("id");
        if (id) dispatch(fetchNewsById(id));
      } finally {
        setPageLoading(false);
      }
    };

    if (isAuthenticated) {
      loadAll();
    } else {
      dispatch(loginAnonymously()).then(loadAll);
    }
  }, [isAuthenticated, activeCategory, sourceIds, location.search]);

  const [shareUrl, setShareUrl] = useState(
    window.location.origin + location.pathname + location.search,
  );
  const [title, setTitle] = useState("Brieffo");

  useEffect(() => {
    const baseURL = new URL(shareUrl).origin;
    setShareUrl(`${baseURL}/lajmet?id=${activeNews?.id}`);
    setTitle(activeNews?.title || "Brieffo");
  }, [activeNews, shareUrl]);

  const latestPostByCategory = useSelector(selectLatestPostByCategory);

  // useEffect(() => {
  //   if (news.length !== 0 && newsActiveIndex === news.length - 3) {
  //     dispatch(fetchNews(currentPage + 1, activeCategory, sourceIds, country));
  //   }
  // }, [newsActiveIndex, news.length, currentPage, activeCategory, dispatch, sourceIds, country]);

  //   useEffect(() => {
  //   if (
  //     news.length !== 0 &&
  //     newsActiveIndex === news.length - 3 &&
  //     currentPage + 1 < Math.ceil(news.length / 10) // or totalPages if you have it
  //   ) {
  //     dispatch(fetchNews(currentPage + 1, activeCategory, sourceIds, country));
  //   }
  // }, [newsActiveIndex, news.length, currentPage, activeCategory, dispatch, sourceIds, country]);

  useEffect(() => {
    if (
      news.length !== 0 &&
      newsActiveIndex >= news.length - 3 &&
      currentPage + 1 < totalPages
    ) {
      dispatch(fetchNews(currentPage + 1, activeCategory, sourceIds, country));
    }
  }, [
    newsActiveIndex,
    news.length,
    currentPage,
    totalPages,
    activeCategory,
    sourceIds,
    country,
    dispatch,
  ]);

  const resetSwiperActiveIndex = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideTo(0, 0);
      swiperRef.current.swiper.activeIndex = null;
    }
  };

  const onNextNewsHandler = () => {
    dispatch(nextActiveNewsAction());
  };

  const onPrevNewsHandler = () => {
    dispatch(prevActiveNewsAction());
  };

  function convertTimestampToHoursAgo(timestamp: string): string {
    const parseTimestamp = new Date(timestamp);
    const currentTime = new Date();
    const timeDifferenceInMinutes =
      (currentTime.getTime() - parseTimestamp.getTime()) / (1000 * 60);

    const minutesAgo = Math.floor(timeDifferenceInMinutes);
    if (minutesAgo < 60) {
      return minutesAgo < 1
        ? "tani"
        : `${minutesAgo} ${minutesAgo === 1 ? "minut" : "minuta"} më parë`;
    }
    return `${Math.floor(timeDifferenceInMinutes / 60)} orë më parë`;
  }

  // function calculateReadingTime(text: string | undefined, wpm = 70): string {
  //   if (!text || text.trim().length === 0) {
  //     return "";
  //   }

  //   const words = text.trim().split(/\s+/).length;
  //   const minutes = words / wpm;

  //   if (minutes < 0.5) return "Më pak se 1 min lexim";

  //   const roundedMinutes = Math.ceil(minutes);
  //   return `${roundedMinutes} min lexim`;
  // }

  const [openDrawer, setOpenDrawer] = useState(false);

  const showDrawer = () => setOpenDrawer(true);
  const onCloseDrawer = () => setOpenDrawer(false);

  const getColor = (name: string) => {
    switch (name) {
      case "Lajme":
        return "#0D5A03";
      case "Politike":
        return "#285ADC";
      case "Lifestyle":
        return "#1588FF";
      case "Sport":
        return "#F4BF4E";
      case "Showbiz":
        return "#0D5A03";
      case "Te tjera":
        return "red";
      default:
        return "#000";
    }
  };

  const backButton = () => {
    navigate(`/lajmet`);
    setActiveCategory("");
  };

  const [placeholder, setPlaceholder] = useState("Kerko lajmin");

  const onFocus = () => setPlaceholder("");
  const onBlur = () => !search && setPlaceholder("Kerko lajmin");

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearch(value);
    if (value.trim().length > 3) {
      dispatch(setSearchValue(value));
    }
  };

  const handleSearch = (query: string) => {
    if (query.trim().length >= 3) {
      navigate("/search");
    }
  };

  const [currentNew, setCurrentNew] = useState(null);

  const showNewsModalFunction = (currentNews: any) => {
    // List of sources that should open in a new tab
    const openInNewTabSources = ["Sinjali", "Telegrafi", "Insajderi"];

    // Check if the news source should open in a new tab
    if (
      currentNews?.source?.name &&
      openInNewTabSources.includes(currentNews.source.name)
    ) {
      window.open(currentNews.originalPostUrl, "_blank");
    } else {
      setCurrentNew(currentNews);
      setShowNewsModal(true);
    }
  };

  const [favoriteStatus, setFavoriteStatus] = useState<{
    [key: string]: boolean;
  }>({});

  useEffect(() => {
    const initialFavoriteStatus: { [key: string]: boolean } = {};
    news.forEach((newsItem: any) => {
      initialFavoriteStatus[newsItem.id] = newsItem.isFavorite || false;
    });
    setFavoriteStatus(initialFavoriteStatus);
  }, [news]);

  const handleBookmarkToggle = (currentNews: any) => {
    if (isAuthenticated) {
      const updatedFavoriteStatus = {
        ...favoriteStatus,
        [currentNews.id]: !favoriteStatus[currentNews.id],
      };
      setFavoriteStatus(updatedFavoriteStatus);
      if (updatedFavoriteStatus[currentNews.id]) {
        dispatch(addSavedNews(currentNews.id));
      } else {
        dispatch(removeSavedNews(currentNews.id));
      }
    } else {
      message.info("Ju lutemi kyquni per te ruajtur lajmet");
      navigate("/login");
    }
  };
  const [isIphoneSE, setIsIphoneSE] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      // iPhone SE 3rd gen: portrait or landscape
      const se3 =
        /iPhone/.test(navigator.userAgent) &&
        ((width === 375 && height >= 667 && height <= 680) || // portrait, allow slight variation
          (height === 375 && width >= 667 && width <= 680)); // landscape

      const mobile = width <= 425 && !se3;
      const tablet = width > 425 && width <= 768;

      setIsIphoneSE(se3);
      setIsMobile(mobile);
      setIsTablet(tablet);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const openShareModal = () => setShareModalOpen(true);

  const handleOpenApp = () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const storeUrl = isIOS
      ? "https://apps.apple.com/us/app/online-kosova/id6447425775"
      : "https://play.google.com/store/apps/details?id=com.onlinekosova.android&hl=en_US&pli=1";
    window.open(storeUrl, "_blank");
  };

  // News ticker content
  const tickerText =
    "Gjithçka që ndodh në Kosovë, në një aplikacion të vetëm. Shkarko tani!";

  // if (pageLoading) {
  //   return (
  //     <div style={{ height: "100vh", background: "red" }}>
  //       LOADING
  //     </div>
  //   );
  // }

  if (pageLoading) {
    return <HomeSkeleton />;
  }

  return (
    <div>
      <NewsModal
        showModal={showNewsModal}
        activeNews={currentNew}
        setShowModal={setShowNewsModal}
      />
      <ShareModal
        showModal={shareModalOpen}
        shareUrl={shareUrl}
        setShowModal={setShareModalOpen}
      />
      {activeNews && (
        <div
          style={{
            width: "100%",
            height: "100vh",
            backgroundColor: activeNews.imageUrl ? "black" : "",
            backgroundImage: activeNews.imageUrl
              ? `url(${activeNews.imageUrl})`
              : "",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <SideDrawer
            isOpen={openDrawer}
            onClose={onCloseDrawer}
            isAuthenticated={isAuthenticated}
          />

          <div className={classes.centerDiv}>
            <div className={classes.blurOverlay} />
            {isBannerVisible && (
              <div
                className={classes.bannerWrapper}
                style={{
                  width: "100%",
                  marginTop: 10,
                  padding: 0,
                  position: "relative",
                }}
              >
                <button
                  onClick={() => setIsBannerVisible(false)}
                  className={classes.closeButton}
                  style={{
                    borderStyle: "none",
                    backgroundColor: "#1E90FF",
                    padding: "0px 7px",
                    marginLeft: 8,
                    marginRight: 1,
                    borderRadius: "100px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    cursor: "pointer",
                    transition: "transform 0.1s ease",
                    color: "#fff",
                  }}
                >
                  ×
                </button>
                <Row
                  gutter={0}
                  justify="space-between"
                  align="middle"
                  style={{
                    backgroundColor: "#f5f5f5",
                    borderRadius: "12px",
                    padding: "10px 15px",
                    width: "100%",
                    margin: 0,
                  }}
                >
                  <Col span={24}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      {!isMobile && (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={logoGlobe}
                            alt="Online Kosova Logo"
                            style={{
                              width: "40px",
                              height: "40px",
                              marginRight: "10px",
                            }}
                          />
                          <div>
                            <span
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "#000",
                              }}
                            >
                              Brieffo
                            </span>
                            <p
                              style={{
                                fontSize: "12px",
                                color: "#888",
                                margin: 0,
                              }}
                            >
                              News
                            </p>
                          </div>
                        </div>
                      )}

                      {!isMobile && (
                        <div className={classes.tickerWrapper}>
                          <div className={classes.tickerContent}>
                            <span className={classes.tickerText}>
                              {tickerText}
                            </span>
                          </div>
                        </div>
                      )}

                      <div
                        style={{
                          display: "flex",
                          justifyContent: isMobile ? "center" : "flex-end",
                          alignItems: "center",
                          marginRight: isMobile ? "50px" : "40px",
                        }}
                      >
                        <a
                          href="https://apps.apple.com/us/app/online-kosova/id6447425775"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={appstore}
                            alt="App Store"
                            style={{
                              borderStyle: "none",
                              width: isMobile ? "100px" : "130px",
                              marginRight: isMobile ? "20px" : "20px",
                              marginLeft: isMobile ? "30px" : "20px",
                              cursor: "pointer",
                              transition: "transform 0.1s ease",
                            }}
                          />
                        </a>
                        <a
                          href="https://play.google.com/store/apps/details?id=com.onlinekosova.android&pli=1"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={googleplay}
                            alt="Google Play"
                            style={{
                              borderStyle: "none",
                              width: isMobile ? "100px" : "130px",
                              marginRight: isMobile ? "10px" : "10px",
                              cursor: "pointer",
                              transition: "transform 0.1s ease",
                            }}
                          />
                        </a>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            )}

            <Row
              className={classes.headerRow}
              align="middle"
              style={{ margin: 0 }}
            >
              {/*same width as right */}
              <Col xs={6} sm={6} md={8} lg={8} xl={8} />

              <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                <div className={classes.centerLogo}>
                  <>
                    <img
                      src={logo}
                      alt="Online Kosova"
                      className={classes.logoImg}
                    />
                  </>
                </div>
              </Col>

              <Col xs={6} sm={6} md={8} lg={8} xl={8}>
                <div className={classes.iconGroup}>
                  {!searchOpen ? (
                    <>
                      <FiSearch
                        className={classes.headerIcon}
                        onClick={() => setSearchOpen(true)}
                      />
                      <span className={classes.iconDivider} />
                      <Tooltip
                        title="Zgjedh shtetin"
                        placement="bottom"
                        open={highlightWorld}
                      >
                        <FaGlobeEurope
                          className={`${classes.headerIcon} ${
                            highlightWorld ? classes.worldHint : ""
                          }`}
                          onClick={() => navigate("/selectstate")}
                        />
                      </Tooltip>
                      <span className={classes.iconDivider} />
                      <RxHamburgerMenu
                        className={classes.headerIcon}
                        onClick={showDrawer}
                      />
                    </>
                  ) : (
                    <>
                      <Search
                        autoFocus
                        className={classes.headerSearchInput}
                        placeholder="Kerko lajmin"
                        value={search}
                        onChange={handleInputChange}
                        onSearch={(q) => {
                          handleSearch(q);
                          setSearchOpen(false);
                        }}
                        onBlur={() => setSearchOpen(false)}
                        onKeyDown={(e) =>
                          e.key === "Escape" && setSearchOpen(false)
                        }
                      />

                      <span className={classes.iconDivider} />

                      <Tooltip
                        title="Zgjedh shtetin"
                        placement="bottom"
                        open={highlightWorld}
                      >
                        <FaGlobeEurope
                          className={`${classes.headerIcon} ${
                            highlightWorld ? classes.worldHint : ""
                          }`}
                          onClick={() => navigate("/selectstate")}
                        />
                      </Tooltip>

                      <span className={classes.iconDivider} />

                      <RxHamburgerMenu
                        className={classes.headerIcon}
                        onClick={showDrawer}
                      />
                    </>
                  )}
                </div>
              </Col>
            </Row>

            {activeCategory && (
              <Row>
                <Col span={24}>
                  <div className={classes.backButton} onClick={backButton}>
                    <HiArrowLeft fontSize="1.2rem" color="white" />
                    <h2>Rikthehuni</h2>
                  </div>
                </Col>
              </Row>
            )}
            <Swiper
              style={{
                marginTop: isIphoneSE
                  ? "20px" // special margin for iPhone SE
                  : isMobile
                    ? "100px" // other mobile devices
                    : isTablet
                      ? "30px"
                      : "0px", // desktop
              }}
              ref={swiperRef}
              spaceBetween={0}
              grabCursor={true}
              keyboard={{ enabled: true }}
              slidesPerView={1}
              mousewheel={{
                forceToAxis: true,
                releaseOnEdges: true,
                sensitivity: 2.5,
                thresholdDelta: 30,
              }}
              freeMode={false}
              direction="vertical"
              className={classes.swiperDiv}
              modules={[Mousewheel, Keyboard, Navigation, A11y]}
              onSlideNextTransitionStart={onNextNewsHandler}
              onSlidePrevTransitionStart={onPrevNewsHandler}
              speed={800}
              threshold={10}
              touchRatio={0.5}
              slideToClickedSlide={false}
            >
              {news.map((currentNews: any) => (
                <SwiperSlide
                  key={currentNews.id}
                  className={classes.swiperSliderDiv}
                >
                  <Row className={classes.mainRow} gutter={[16, 8]}>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={12}
                      xl={12}
                      className={classes.mainRowNews}
                      onClick={() => showNewsModalFunction(currentNews)}
                    >
                      <div className={classes.categoriesDiv}>
                        <div className={classes.categoriesBox}>
                          <h4>{currentNews.categories[0]?.name}</h4>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          <h4>
                            {convertTimestampToHoursAgo(
                              currentNews.publishedDate,
                            )}
                          </h4>
                          <span aria-hidden="true" style={{ color: "white" }}>
                            {" "}
                            |{" "}
                          </span>
                          <h4>{currentNews.readTimeMinutes} min lexim</h4>
                        </div>
                      </div>
                      <div className={classes.titleSection}>
                        <h1>{currentNews.title}</h1>
                      </div>
                      <div className={classes.subtitleSection}>
                        <h3>
                          {currentNews.subTitle.length <= 150
                            ? currentNews.subTitle
                            : currentNews.subTitle.slice(0, 250) + "..."}
                        </h3>
                      </div>
                      <div className={classes.modalSection}>
                        <h4
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.2rem",
                            fontSize: "1rem",
                            fontWeight: "700",
                            color: "#1588FF",
                          }}
                        >
                          Lexoni lajmin e plote{" "}
                          <IoIosArrowRoundForward
                            style={{ fontSize: "1.5rem" }}
                          />
                        </h4>
                      </div>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={12}
                      xl={12}
                      className={classes.rightSectionNews}
                    >
                      <div className={classes.imageRowNews}>
                        <div
                          className={classes.mainImageRow}
                          style={{
                            backgroundImage: `url("${
                              currentNews.imageUrl || noImage
                            }")`,

                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        ></div>
                        <div className={classes.sourceSaveShareSection}>
                          <div className={classes.sourceSection}>
                            <Image
                              preview={false}
                              width={"2rem"}
                              height={"2rem"}
                              src={currentNews.source.sourceImage}
                              style={{
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                            <h4>{currentNews.source.name}</h4>
                          </div>
                          <div className={classes.saveShareSection}>
                            <div
                              onClick={() => handleBookmarkToggle(currentNews)}
                              className={classes.saveButton}
                            >
                              {favoriteStatus[currentNews.id] ? (
                                <FaBookmark
                                  fontSize={"1.2rem"}
                                  color={"white"}
                                  className={classes.isFavoriteIcon}
                                />
                              ) : (
                                <FaRegBookmark
                                  fontSize={"1.2rem"}
                                  color={"white"}
                                  className={classes.isNotFavoriteIcon}
                                />
                              )}
                            </div>
                            <div
                              onClick={openShareModal}
                              className={classes.shareButton}
                            >
                              <IoIosShareAlt
                                fontSize={"1.5rem"}
                                color={"white"}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <SwiperNavButtons />
                      </div>
                    </Col>
                  </Row>
                </SwiperSlide>
              ))}
            </Swiper>

            <Row className={classes.categoryPart}>
              <Col span={24}>
                <div className={classes.bottomPart}>
                  <h2>| TOP NGJARJET</h2>
                  <WeatherWidget />
                </div>
                <div>
                  {categories && (
                    <Swiper
                      grabCursor={true}
                      keyboard={{
                        enabled: true,
                      }}
                      slidesPerView={5}
                      modules={[Keyboard, Navigation, A11y, Autoplay]}
                      breakpoints={{
                        1460: {
                          spaceBetween: 4,
                          slidesPerView: 4,
                        },
                        1120: {
                          spaceBetween: 4,
                          slidesPerView: 3,
                        },
                        768: {
                          spaceBetween: 20,
                          slidesPerView: 2,
                        },
                        480: {
                          spaceBetween: 20,
                          slidesPerView: 1,
                        },
                        0: {
                          // Mobile: 1 full-width card
                          slidesPerView: 1,
                          spaceBetween: 10,
                        },
                      }}
                      autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                      }}
                      speed={2000}
                      loop={true}
                      cssMode={false}
                    >
                      {latestPostByCategory.content.map((category, index) => (
                        <SwiperSlide
                          key={`${category.id}-${index}`}
                          virtualIndex={index}
                        >
                          <Card
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              width: "100%",
                              height: "5rem",
                              backgroundSize: "cover",
                              backgroundRepeat: "no-repeat",
                              borderRadius: 0,
                              border: "none",
                              backgroundColor: "transparent",
                              overflow: "hidden",
                              paddingLeft: "-20px",
                            }}
                          >
                            <div
                              className={classes.categoriesBoxCard}
                              onClick={() => {
                                setActiveCategory(category.categories[0].id);
                                navigate(
                                  `/lajmet?category=${category.categories[0].id}`,
                                );
                              }}
                            >
                              <div className={classes.categoriesCardName}>
                                <RxDividerVertical
                                  style={{
                                    color: getColor(
                                      category.categories[0].name,
                                    ),
                                    fontSize: "1.5rem",
                                  }}
                                />
                                <h4>{category.categories[0].name}</h4>
                              </div>
                              <div className={classes.categoriesPost}>
                                {category.title}
                              </div>
                            </div>
                          </Card>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}
    </div>
  );
};

export default News;
